<div class="content-height d-lg-block d-none">
    <div class="row h-100">
        <div class="col-6 image-section position-relative">
            <div class="mt-2">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper [steps]="steps" class="mb-6"></apnst-material-stepper>
                    <img class="img img-fluid " src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718172770776Working%203d%201%20%283%29.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n1">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718082698806Notification%201.png" alt="">
                            </div>
                            <div class="w-100 mt-1">
                                <h6>What is a Collateral?</h6>
                                <p class="fs-8">Collateral is a security deposit accepted by banks in order to borrow money in the form of residential, commercial, fixed deposit and plot.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mx-2 bg-light border-warning-faint">
                        <div class="col-1 faq-warning-div-height mt-n0">
                            <h6 class="rotate-text text-center mt-4 py-3">NOTE</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718086250706Notification%201%20%281%29.png" alt="">
                            </div>
                            <div class="w-100 mt-1">
                                <p class="fs-8">If you have a collateral which is lesser in value than loan amount, you can still choose loan with co-applicant (Unsecured Loan). Also, Collateral used in the Loan should be ideally free from any legal matters.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6">
            <div class="container overflow-hidden">
                <div>
                    <apnst-common-header [configHeader]="configCollateralDetailsHeader" [showHeaderWeb]="true" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
                </div>

                <div>
                    <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmitResponse)="onSubmit($event)" [layout]="layout">
                    </aerp-base-schema-form>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="d-lg-none d-block">
    <div class="container">

        <div class="fixed-header">
            <div class="mt-5">
                <apnst-material-stepper [steps]="steps"></apnst-material-stepper>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <apnst-common-header [configHeader]="configCollateralDetailsHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>

                <p class="text-primary-dark me-3 mt-1" (click)="openModalforFAQ()"><i class="bi bi-question-circle me-1"></i>FAQ
                </p>
            </div>

        </div>

        <div class="scrollable-content">
            <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmitResponse)="onSubmit($event)" [layout]="layout">
            </aerp-base-schema-form>
        </div>
    </div>
</div>


<ng-template #openFAQModal let-modal>
    <div class="modal-header">
        <p class="text-gray mb-n2 text-center">Frequently Asked Questions</p>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
        <div>
            <div>
                <h6>What is a Collateral?</h6>
                <p>Collateral is a security deposit accepted by banks in order to borrow money in the form of residential, commercial, fixed deposit and plot.</p>
            </div>
            <hr>

            <div>
                <h6>What should be the value of the Collateral?</h6>
                <p>The value of the collateral must be always greater than the required loan amount.</p>
            </div>
        </div>
    </div>
</ng-template>